export default __webpack_public_path__ + "static/media/OmaduroTorpedoClosed.f57fe7ec.jpg";